import React from "react"

interface LineTwoToThreeProps {
  rotate?: boolean // 회전 각도를 props로 받음 (기본값 0)
}

const LineTwoToThree: React.FC<LineTwoToThreeProps> = ({ rotate = false }) => {
  return (
    <svg
      width="254"
      height="181"
      viewBox="0 0 254 181"
      fill="none"
      style={{
        transform: rotate ? "rotate(180deg)" : "none",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.63003 177.689C0.838321 178.243 0.645912 179.335 1.20027 180.126C1.75463 180.918 2.84584 181.11 3.63755 180.556L1.63003 177.689ZM253.379 5.05921C253.547 4.1074 252.912 3.19974 251.96 3.03191L236.449 0.296951C235.497 0.129117 234.59 0.764658 234.422 1.71649C234.254 2.6683 234.89 3.57595 235.841 3.74378L249.629 6.17485L247.198 19.9622C247.03 20.914 247.665 21.8216 248.617 21.9895C249.569 22.1573 250.477 21.5217 250.644 20.5699L253.379 5.05921ZM3.63755 180.556L252.66 6.18883L250.652 3.3218L1.63003 177.689L3.63755 180.556Z"
        fill="#4282EF"
      />
    </svg>
  )
}

export default LineTwoToThree
